import { render, staticRenderFns } from "./AverageDeliveryTimeByHub.vue?vue&type=template&id=56e68f6c&lang=pug&"
import script from "./AverageDeliveryTimeByHub.vue?vue&type=script&lang=ts&"
export * from "./AverageDeliveryTimeByHub.vue?vue&type=script&lang=ts&"
import style0 from "./AverageDeliveryTimeByHub.vue?vue&type=style&index=0&id=56e68f6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports